/**
 * @fileoverview Public tools — the English (EN) bundle (LINKABLE-ASSETS-001 C1).
 * @package @puffin-core/public-tools
 *
 * The words the tool SURFACE renders — the breadcrumb landmark, the provenance stamp, the two
 * disclaimers, the calculator chrome and its refusals. A page's OWN copy (its title, its intro, its
 * table's captions and its fields' labels) lives in the brand portal's `common.json`, never here.
 *
 * The three disclaimers are the honesty rows of the plan (D-5 / D8): a legal-shaped page is general
 * information, not legal advice; a rate-shaped page quotes published list rates with fuel and
 * accessorial surcharges excluded; a schedule-shaped page (holiday ship-by dates) quotes a
 * carrier's published guidance, not a delivery guarantee. They are keyed by the provenance `kind`
 * the page declares (`disclaimerLegal`, `disclaimerPublishedRates`,
 * `disclaimerPublishedSchedule`), so a page cannot render the wrong one.
 *
 * Placeholders use SINGLE braces (`{date}`), the interpolator `usePublicToolsTranslate` binds.
 */

export const PUBLIC_TOOLS_EN = Object.freeze({
  // The page frame
  breadcrumbsLabel: 'You are here',
  relatedHeading: 'Related tools',

  // The provenance stamp
  provenanceLabel: 'About this information',
  lastVerified: 'Last verified {date}',
  version: 'Version {version}',
  sourcePrefix: 'Source:',
  disclaimerLegal:
    'This is general information, not legal advice. Check the cited source and your own counsel before you act on it.',
  disclaimerPublishedRates:
    'Published list rates; fuel and accessorial surcharges excluded. The carrier’s current guide governs.',
  disclaimerPublishedSchedule:
    'These dates are the carrier’s published guidance for the contiguous United States unless stated otherwise, not a delivery guarantee. The carrier’s current notice governs.',

  // The calculator
  calculateSubmit: 'Calculate',
  calculateReset: 'Start over',
  resultsLabel: 'Results',
  error_fieldRequired: 'Enter a value.',
  error_fieldNumber: 'Enter a number.',
  error_fieldMin: 'Enter a number of at least {min}.',
  error_fieldMax: 'Enter a number no greater than {max}.',
  error_fieldPattern: 'Enter a value in the expected format.',
});
